<script setup lang="ts">
    import {computed} from "vue";

    interface Item {
        type:  'whatsapp' | 'ticket-open' | 'ticket-close' | 'status-update' | 'outbound-message' | 'outbound-call',
        content: string,
        time: string,
        id?: string | number
    }

    const props = defineProps<{
        item: Item
    }>()

    const link_items = ['whatsapp', 'ticket-open', 'ticket-close', 'status-update', 'outbound-call']
    const to = computed(() => {
        if (link_items.includes(props.item.type)) {
            switch (props.item.type) {
                case 'outbound-call':
                    return "/calls/view/" + props.item.id
                case 'whatsapp':
                    return "/whatsapps/" + props.item.id
                case 'ticket-open':
                case 'ticket-close':
                    return "/tickets/view/" + props.item.id
            }
        }
        return null
    })

    const icon_name = computed(() => {
        switch (props.item.type) {
            case 'status-update':
                return 'circle'
            case 'outbound-call':
                return 'call-voice'
            case 'whatsapp':
                return 'brand-whatsapp'
            case 'ticket-close':
            case 'ticket-open':
                return 'speechbubble-double'
            default:
                return 'circle'
        }
    })

    const platform = computed(() => {
        if (link_items.includes(props.item.type)) {
            switch (props.item.type) {
                case 'status-update':
                    return "Order Event"
                case 'outbound-call':
                    return "Call"
                case 'whatsapp':
                    return "WhatsApp"
                case 'outbound-message':
                    return "WhatsApp Payment Reminder"
                case 'ticket-open':
                    return "Ticket opened."
                case 'ticket-close':
                    return "Ticket closed."
            }
        }
        return null
    })
</script>

<template>
    <component :is="to ? 'router-link' : 'div'" class="order-history-item" :to>
        <div class="order-history-item-info">
            <p class="order-history-item-time">{{ item.time }}</p>
            <ah-icon :name="icon_name"/>

            <div class="order-history-item-content">
                <p class="order-history-item-content-platform" v-if="platform">{{ platform }}</p>
                <p class="order-history-item-content-description">{{ item.content }}</p>
            </div>
        </div>

        <ah-icon name="chevron-right" v-if="to"/>
    </component>
</template>

<style scoped lang="scss">
.order-history-item {
    height: 6.8rem;
    background: var(--color-grey-mist);
    border-radius: 2.4rem;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    gap: 2rem;
    justify-content: space-between;

    .order-history-item-info {
        display: flex;
        align-items: center;
        gap: 2rem;

        .order-history-item-time {
            @include font(1.4, 1.4, black);
            color: var(--color-grey-thunder);
        }

        .icon {
            fill: var(--color-tiffany-dark);
        }

        .order-history-item-content {
            display: flex;
            flex-direction: column;
            gap: .4rem;

            .order-history-item-content-platform {
                @include font(1, 1, black);
                color: #768692;
            }

            .order-history-item-content-description {
                @include font(1.4, 1.4, book);
            }
        }
    }

    .icon {
        fill: var(--color-grey-hazy);
    }

    @include dark() {
        background: var(--color-darth-sidious);

        .order-history-item-info {
            p, div {
                color: var(--color-white) !important;
            }
        }
    }
}
</style>
